export const DEFAULT_IMAGE_MODEL = 'gemini-3-pro-image-preview';

export const IMAGE_MODEL_OPTIONS = [
  {
    value: DEFAULT_IMAGE_MODEL,
    label: 'Nano Banana Pro',
    description: 'Best quality, complex layouts, product mockups, accurate text',
  },
  {
    value: 'gemini-3.1-flash-image-preview',
    label: 'Nano Banana 2',
    description: 'Faster, lower cost, high-volume generation',
  },
];

export const IMAGE_MODEL_COSTS = {
  'gemini-3-pro-image-preview': {
    '1k': 0.14,
    '2k': 0.14,
    '4k': 0.25,
  },
  'gemini-3.1-flash-image-preview': {
    '1k': 0.07,
    '2k': 0.10,
    '4k': 0.15,
  },
};

export const normalizeImageModel = (value) => {
  if (value === 'nano-banana-pro') return DEFAULT_IMAGE_MODEL;
  if (value === 'nano-banana-2') return 'gemini-3.1-flash-image-preview';
  return IMAGE_MODEL_OPTIONS.some((option) => option.value === value)
    ? value
    : DEFAULT_IMAGE_MODEL;
};

export const getImageCost = (model, resolution) => {
  const modelCosts = IMAGE_MODEL_COSTS[normalizeImageModel(model)] || IMAGE_MODEL_COSTS[DEFAULT_IMAGE_MODEL];
  return modelCosts[String(resolution || '1k').toLowerCase()] || modelCosts['1k'];
};

export const getImageModelLabel = (model) => {
  const option = IMAGE_MODEL_OPTIONS.find((item) => item.value === model);
  return option ? option.label : model;
};
